// NIGHT-DIRECTSTAFF-2026-10-25d §2: staff roles -- owner / recruiter (2026-10-26-staff-roles.sql, filed). Owner-only: merge, test-mark,
// bulk actions, Settings, Export. A recruiter sees everything else. Before the hub applies the file (staff_role() missing) everyone is
// an owner, exactly as today -- nothing is taken away by a migration not yet there.
export const OWNER_ONLY = ['merge', 'test-mark', 'bulk actions', 'Settings', 'Export'];
/** -> 'owner' | 'recruiter' (anything unreadable = owner, as today) */
export async function loadRole(supabase) {
  try {
    const { data, error } = await supabase.rpc('staff_role');
    if (error) return 'owner';
    return data === 'recruiter' ? 'recruiter' : 'owner';
  } catch (e) { return 'owner'; }
}
export const isOwner = (role) => role !== 'recruiter';
